var _g, _g2, _path, _path2, _g3, _g4, _g5, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14125_22578)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 23,
    r: 15,
    fill: "url(#paint0_linear_14125_22578)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14125_22578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 39C20.2179 39 21.3552 38.4825 22.3426 37.6061C23.3233 36.7356 24.1674 35.5049 24.8559 34.0295C25.5469 32.5489 26.0847 30.8145 26.449 28.93C26.8136 27.0438 27 25.0296 27 23C27 20.9704 26.8136 18.9562 26.449 17.07C26.0847 15.1855 25.5469 13.4511 24.8559 11.9705C24.1674 10.4951 23.3233 9.26438 22.3426 8.39392C21.3552 7.5175 20.2179 7 19 7",
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17H34",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 29H34",
    stroke: "white",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_14125_22578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 39C17.7821 39 16.6448 38.4825 15.6574 37.6061C14.6767 36.7356 13.8326 35.5049 13.1441 34.0295C12.4531 32.5489 11.9153 30.8145 11.551 28.93C11.1864 27.0438 11 25.0296 11 23C11 20.9704 11.1864 18.9562 11.551 17.07C11.9153 15.1855 12.4531 13.4511 13.1441 11.9705C13.8326 10.4951 14.6767 9.26438 15.6574 8.39392C16.6448 7.5175 17.7821 7 19 7",
    stroke: "white",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_14125_22578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16 21.7909 17.7909 20 20 20H48C50.2091 20 52 21.7909 52 24V44C52 45.1046 51.1046 46 50 46H18C16.8954 46 16 45.1046 16 44V24Z",
    fill: "url(#paint1_linear_14125_22578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16 21.7909 17.7909 20 20 20H48C50.2091 20 52 21.7909 52 24V44C52 45.1046 51.1046 46 50 46H18C16.8954 46 16 45.1046 16 44V24Z",
    fill: "url(#paint2_radial_14125_22578)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C16.5 22.067 18.067 20.5 20 20.5H48C49.933 20.5 51.5 22.067 51.5 24V44C51.5 44.8284 50.8284 45.5 50 45.5H18C17.1716 45.5 16.5 44.8284 16.5 44V24Z",
    stroke: "url(#paint3_radial_14125_22578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C16.5 22.067 18.067 20.5 20 20.5H48C49.933 20.5 51.5 22.067 51.5 24V44C51.5 44.8284 50.8284 45.5 50 45.5H18C17.1716 45.5 16.5 44.8284 16.5 44V24Z",
    stroke: "url(#paint4_radial_14125_22578)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C16.5 22.067 18.067 20.5 20 20.5H48C49.933 20.5 51.5 22.067 51.5 24V44C51.5 44.8284 50.8284 45.5 50 45.5H18C17.1716 45.5 16.5 44.8284 16.5 44V24Z",
    stroke: "url(#paint5_radial_14125_22578)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_14125_22578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 48C12 47.4477 12.4477 47 13 47H55C55.5523 47 56 47.4477 56 48V48.644C56 49.1981 55.8114 49.7357 55.4653 50.1684C54.5391 51.3261 53.137 52 51.6544 52H16.3456C14.863 52 13.4609 51.3261 12.5347 50.1684C12.1886 49.7357 12 49.1981 12 48.644V48Z",
    fill: "url(#paint6_linear_14125_22578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 48C12 47.4477 12.4477 47 13 47H55C55.5523 47 56 47.4477 56 48V48.644C56 49.1981 55.8114 49.7357 55.4653 50.1684C54.5391 51.3261 53.137 52 51.6544 52H16.3456C14.863 52 13.4609 51.3261 12.5347 50.1684C12.1886 49.7357 12 49.1981 12 48.644V48Z",
    fill: "url(#paint7_radial_14125_22578)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 48C12.5 47.7239 12.7239 47.5 13 47.5H55C55.2761 47.5 55.5 47.7239 55.5 48V48.644C55.5 49.0846 55.3501 49.512 55.0749 49.856C54.2436 50.8951 52.9851 51.5 51.6544 51.5H16.3456C15.0149 51.5 13.7564 50.8951 12.9251 49.856L12.5347 50.1684L12.9251 49.856C12.6499 49.512 12.5 49.0846 12.5 48.644V48Z",
    stroke: "url(#paint8_radial_14125_22578)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30C32 29.4477 32.4477 29 33 29H36C36.5523 29 37 29.4477 37 30V42C37 42.5523 36.5523 43 36 43H33C32.4477 43 32 42.5523 32 42V30Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 32C39 31.4477 39.4477 31 40 31H43C43.5523 31 44 31.4477 44 32V42C44 42.5523 43.5523 43 43 43H40C39.4477 43 39 42.5523 39 42V32Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36C25 35.4477 25.4477 35 26 35H29C29.5523 35 30 35.4477 30 36V42C30 42.5523 29.5523 43 29 43H26C25.4477 43 25 42.5523 25 42V36Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C24 34.8954 24.8954 34 26 34H27C28.1046 34 29 34.8954 29 36V41C29 41.5523 28.5523 42 28 42H25C24.4477 42 24 41.5523 24 41V36Z",
    fill: "#F4F4F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30C31 28.8954 31.8954 28 33 28H34C35.1046 28 36 28.8954 36 30V41C36 41.5523 35.5523 42 35 42H32C31.4477 42 31 41.5523 31 41V30Z",
    fill: "#F4F4F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32C38 30.8954 38.8954 30 40 30H41C42.1046 30 43 30.8954 43 32V41C43 41.5523 42.5523 42 42 42H39C38.4477 42 38 41.5523 38 41V32Z",
    fill: "#F4F4F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14125_22578",
    x: 0,
    y: 4,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14125_22578",
    x: 15,
    y: 2,
    width: 17,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_14125_22578",
    x: 6,
    y: 2,
    width: 17,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_14125_22578",
    x: 8,
    y: 12,
    width: 52,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_14125_22578",
    x: 4,
    y: 39,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14125_22578",
    x1: 4,
    y1: 8,
    x2: 19,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14125_22578",
    x1: 16,
    y1: 20,
    x2: 26.3823,
    y2: 48.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 20) scale(36 26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5 36.9722) rotate(4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 24.6944) rotate(144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5 25.0556) rotate(124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14125_22578",
    x1: 12,
    y1: 47,
    x2: 12.354,
    y2: 53.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 47) scale(44 5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_14125_22578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 47) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.fdcae547362e45fd0ea5b69ab380fc6f.svg";
export { ForwardRef as ReactComponent };